// extracted by mini-css-extract-plugin
module.exports = {"bareList":"Markdown_bareList__CjwOr"};